import Header from './Header';
import HeaderContainer from './Header.container';

export default HeaderContainer(Header);
